import { useMediaQuery, useWindowSize } from "@vueuse/core"
import { computed } from "vue"

// set to match tailwind LG
export const SMALLSCREEN = 1024

export function useIsMobile() {
  const { width } = useWindowSize()

  const isMobile = computed(() => width.value < SMALLSCREEN)

  return { isMobile }
}

export function useIsTouchDevice() {
  return { isTouchDevice: useMediaQuery("(hover: none) and (pointer: coarse)") }
}
